ThemeJS.Floating_Reviews_Badge = (function () {
  function init() {
    var badge = document.querySelector("[data-floating-reviews-badge]");
    var footer = document.querySelector("footer.footer");

    if (!badge || !footer) {
      return;
    }

    if (!("IntersectionObserver" in window)) {
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          badge.classList.toggle("is-footer-hidden", entry.isIntersecting);
        });
      },
      {
        root: null,
        threshold: 0,
        rootMargin: "0px",
      }
    );

    observer.observe(footer);
  }

  jQuery(init);

  return {
    init: init,
  };
})();
